import { render, staticRenderFns } from "./LabelsGenerationModal.vue?vue&type=template&id=1a775ae8&"
import script from "./LabelsGenerationModal.vue?vue&type=script&lang=js&"
export * from "./LabelsGenerationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports